module.exports = __webpack_public_path__ + "media/images/newsweek-44e395e6af10fbf6c0701ce86ff167b4d72496e98343eca13375bd3dca31b932.jpg";